import { assets } from '@/config'
const { assetsRoot, userAvatarAssetPath } = assets

const getters = {

  /**
   * @param state
   */
  getUserAvatarURL: state => {
    if (state.user.avatar) return assetsRoot + userAvatarAssetPath + state.user.avatar
    return null
  },

  /**
   * Whether the current user may create a quick order. Reads from the user's
   * company group, which may be absent for some accounts — returns false in
   * that case rather than throwing. Single source of truth for the quick-order
   * gate shared across Index.vue, ProductTiles.vue and AppHeader.vue.
   *
   * @param {object} state - User store module state
   * @returns {boolean} true when the quick-order workflow is enabled for the user
   */
  canCreateQuickOrder: state => {
    const companyGroup = state.user?.companyGroup
    if (!companyGroup) return false

    return Boolean(companyGroup.useCompanyQuickOrderSettings
      ? companyGroup.company?.enableQuickOrderWorkflow
      : companyGroup.enableQuickOrderWorkflow)
  }

}

export default getters
